class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-link');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    if (window.initCartDrawerFBT) {
      window.initCartDrawerFBT();
    }

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (window.initCartDrawerFBT) {
        window.initCartDrawerFBT();
      }
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

(function() {
  let lastCartState = null;
  let isInitialized = false;

  window.initCartDrawerFBT = function() {
    const fbtContainer = document.querySelector('.cart-drawer-fbt');
    if (!fbtContainer) return;

    const slider = fbtContainer.querySelector('[data-fbt-slider]');
    const prevBtn = fbtContainer.querySelector('.cart-drawer-fbt__btn--prev');
    const nextBtn = fbtContainer.querySelector('.cart-drawer-fbt__btn--next');

    if (!slider || !prevBtn || !nextBtn) return;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const cartStateKey = JSON.stringify(cart.items.map(i => i.product_id));
        
        if (cartStateKey !== lastCartState || !isInitialized) {
          lastCartState = cartStateKey;
          isInitialized = true;
          loadFBTProducts(slider, cart);
        } else {
          setupSliderControls(slider);
        }
      })
      .catch(err => console.error('FBT: Failed to load cart', err));
  };

  function loadFBTProducts(slider, cart) {
    if (!cart.items || cart.items.length === 0) {
      slider.innerHTML = '<div class="cart-drawer-fbt__loading">Your cart is empty</div>';
      return;
    }

    const firstProductId = cart.items[0].product_id;
    
    fetch(`/recommendations/products.json?product_id=${firstProductId}&limit=8`)
      .then(r => r.json())
      .then(data => {
        if (!data.products || data.products.length === 0) {
          slider.innerHTML = '<div class="cart-drawer-fbt__loading">No recommendations</div>';
          document.querySelector('.cart-drawer-fbt').classList.add('cart-drawer-fbt--empty');
          return;
        }

        const cartProductIds = cart.items.map(item => item.product_id);
        const products = data.products
          .filter(p => !cartProductIds.includes(p.id))
          .slice(0, 8);

        if (products.length === 0) {
          slider.innerHTML = '<div class="cart-drawer-fbt__loading">No new recommendations</div>';
          document.querySelector('.cart-drawer-fbt').classList.add('cart-drawer-fbt--empty');
          return;
        }

        slider.innerHTML = products.map(product => {
          const variant = product.variants[0];
          const imageUrl = product.featured_image || (product.images && product.images[0]);
          const price = variant ? formatMoney(variant.price) : '';

          return `
            <div class="cart-drawer-fbt__card">
              <a href="/products/${product.handle}">
                <div class="cart-drawer-fbt__card-image">
                  ${imageUrl ? `<img src="${imageUrl}" alt="${escapeHtml(product.title)}" loading="lazy">` : ''}
                </div>
                <h4 class="cart-drawer-fbt__card-title">${escapeHtml(product.title)}</h4>
                <div class="cart-drawer-fbt__card-price">${price}</div>
              </a>
            </div>
          `;
        }).join('');

        setTimeout(() => setupSliderControls(slider), 100);
      })
      .catch(err => {
        console.error('FBT: Failed to load recommendations', err);
        slider.innerHTML = '<div class="cart-drawer-fbt__loading">Unable to load</div>';
      });
  }

  function setupSliderControls(slider) {
    const fbtContainer = slider.closest('.cart-drawer-fbt');
    if (!fbtContainer) return;

    let prevBtn = fbtContainer.querySelector('.cart-drawer-fbt__btn--prev');
    let nextBtn = fbtContainer.querySelector('.cart-drawer-fbt__btn--next');
    
    const cards = slider.querySelectorAll('.cart-drawer-fbt__card');
    if (cards.length === 0 || !prevBtn || !nextBtn) return;

    const cardWidth = cards[0].offsetWidth;
    const gap = parseFloat(getComputedStyle(slider).gap) || 12;
    const scrollAmount = cardWidth + gap;

    if (slider._fbtScrollHandler) {
      slider.removeEventListener('scroll', slider._fbtScrollHandler);
    }

    const newPrevBtn = prevBtn.cloneNode(true);
    const newNextBtn = nextBtn.cloneNode(true);
    prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
    nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);

    prevBtn = newPrevBtn;
    nextBtn = newNextBtn;

    function updateButtons() {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const currentScroll = slider.scrollLeft;
      
      prevBtn.disabled = currentScroll <= 1;
      nextBtn.disabled = currentScroll >= maxScroll - 1;
      
      if (maxScroll <= 0) {
        prevBtn.style.visibility = 'hidden';
        nextBtn.style.visibility = 'hidden';
      } else {
        prevBtn.style.visibility = '';
        nextBtn.style.visibility = '';
      }
    }

    prevBtn.addEventListener('click', () => {
      slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    slider._fbtScrollHandler = updateButtons;
    slider.addEventListener('scroll', updateButtons, { passive: true });

    updateButtons();
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      isInitialized = false;
      lastCartState = null;
      setTimeout(() => {
        if (window.initCartDrawerFBT) {
          window.initCartDrawerFBT();
        }
      }, 200);
    });
  }
})();
